import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../../config/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import {Button, Card, DatePicker, Descriptions, Form, DescriptionsProps, Tag, Avatar} from "antd";
import Colors from "../../styles/Colors";
import toast, { Toaster } from "react-hot-toast";
import { PutUsuariIdPerfil } from "../../dao/root/PutUsuariIdPerfil";
import { GetUsuariIdPerfil } from "../../dao/root/GetUsuariIdPerfil";
import { GetUsuariIdPerfilEscolesRols } from '../../dao/root/GetUsuariIdPerfilEscolesRols';
import Login from "./Login";
import Password from "antd/es/input/Password";
import {UploadOutlined} from "@ant-design/icons";
import {BiFilter, BiPencil, BiPlus, BiRefresh} from "react-icons/bi";
import PlantillaModal from "../PlantillaModal";
import ConfiguracioAppModal from "./component/ConfiguracioAppModal";
import dayjs from "dayjs";
import { defaultUser, User } from '../../model/root/User';
import ProfileModal from './component/ProfileModal';
import { UserOutlined, HomeOutlined, BookOutlined, PhoneOutlined, MailOutlined, IdcardOutlined, SafetyCertificateOutlined, BankOutlined, MedicineBoxOutlined, CalendarOutlined, FileTextOutlined, TeamOutlined, StopOutlined} from '@ant-design/icons';


const Profile = () => {
    const { isLoggedIn, userId, page , user} = useContext(AuthContext);
    const { id_usuari, empresa } = useParams();
   
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [usuari, setUsuari] = useState<any>({});
    const [usuariEscoles, setUsuariEscoles] = useState<any>({});
    const [editMode, setEditMode] = useState(false);
    const [modal, setModal] = useState(false);
    const [nouElement, setNouElement] = useState(false);
    const [elementSelected, setElementSelected] = useState<User>(defaultUser);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true);
            checkDades();
        }
    }, [id_usuari, page, isLoggedIn]);

    async function checkDades() {
        handleLoadingChange(true);
        const dades = await GetUsuariIdPerfil(id_usuari || userId, empresa || page);
        console.log(dades);
        console.log(transformarDades(dades[0]));
        setUsuari(dades && dades.length > 0 ? transformarDades(dades[0]) : {});

        const dadesEs = await GetUsuariIdPerfilEscolesRols(id_usuari || userId, empresa || page);
        const us: User = JSON.parse(dadesEs.json);
        setUsuariEscoles(us);
        handleLoadingChange(false);
    }
    async function handleCloseModal(value: boolean) {
        if (value)
            toast.success("GUARDAT");
        else
            toast.error("NO GUARDAT");

        setNouElement(false);
        checkDades();
    }

    function transformarDades(original: any) {
        const naixFills = original.naix
            .replace(/^\[|\]$/g, '') // quitamos los corchetes
            .split(', ')
            .map((dateStr:any) => {
                const cleaned = dateStr.replace(/CEST|CET|GMT\+\d+|UTC/g, '').trim();
                const dateObj = new Date(cleaned);
                return isNaN(dateObj.getTime()) ? null : dayjs(dateObj);

            })
            .filter((date: any): date is string => date !== null); // filtramos nulls con tipo TypeScript

        // Extraemos las disciplines limpiamente
        const disciplines = original.disciplines
            .replace(/^\[|\]$/g, '') // quitamos los corchetes
            .split(' ,')
            .map((d: any) => d.trim());
        const naix = naixFills.map((date: dayjs.Dayjs) => date.year()).join(', ');
        return {
            ...original,
            naix: naix,
            grauDiscapacitatDetall: original.discapacitat,
            convivencia: original.convivencia === 1,
            disciplines: disciplines,
            naixFills: naixFills
        };
    }


    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function handleSave(values: any) {
        handleLoadingChange(true);
        const formData = form.getFieldsValue();
        console.log(formData);
        if (formData.nuevaPassword === formData.repetirNovaPassword) {
            const status = await PutUsuariIdPerfil(id_usuari || userId || "0", page, formData);
            setEditMode(false);
            if (status === 200 || status === 201) {
                toast.success("Dades guardades correctament!");
                await checkDades();
            } else {
                toast.error("Error guardant dades!");
                handleLoadingChange(false);
            }
        } else {
            toast.error("Les contrasenyes no cincideixen!");
            handleLoadingChange(false);
        }
    }

    
    function handleCloseModal2(value: boolean) {
        setModal(false);
    }

    function togleNouElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }

    function afegirElement(element: User) {
        setNouElement(!nouElement);
        setElementSelected(element);
    }
    
    const Items: DescriptionsProps['items'] = [
        {
            key: 'Nom',
            label: 'Nom',
            children: usuari.nombre,
        },
        {
            key: 'Cognoms',
            label: 'Cognoms',
            children: usuari.cognoms,
        },
        {
            key: 'DNI',
            label: <><IdcardOutlined  style={{ marginRight: 6, color: Colors.colors.color1 }} />DNI</>,
            children: usuari.dni,
        },
        {
            key: 'Correu electrònic',
            label: <><MailOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Correu electrònic</>,
            children: usuari.correu,
        },
        {
            key: 'telefon',
            label: <><PhoneOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Telèfon de contacte</>,
            children: usuari.telefon,
        },
        {
            key: 'telefon2',
            label: <><PhoneOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Telèfon alternatiu</>,
            children: usuari.telefon2,
        },
        {
            key: 'Social',
            label: <><SafetyCertificateOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Seguritat Social</>,
            children: usuari.seguretatSocial,
        },
        {
            key: 'IBAN',
            label: <><BankOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />IBAN</>,
            children: usuari.iban,
        },
        
        {
            key: 'Domicili',
            label: <><HomeOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Domicili</>,
            children: usuari.domicili,
        },
        {
            key: 'discapacitat',
            label: <><MedicineBoxOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Grau de discapacitat</>,
            children: usuari.discapacitat,
        },
         
        {
            key: 'Disciplines',
            label: <>
          <BookOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />
          Disciplines
        </>,
            children: usuari.disciplines?.toString() && usuari.disciplines?.toString().trim() !== '' ? (
                usuari.disciplines?.toString()
                .split(',')
                .map((disc: string, idx: number) => (
                    <Tag
                    key={idx}
                    color={Colors.colors.color6}
                    style={{ marginBottom: 4, marginRight: 4, color:'black' }}
                    >
                    {disc.trim()}
                    </Tag>
                ))
            ) : (
                '—'
            ),
            },

        {
            key: 'naix',
            label: <><CalendarOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Anys naixements fills</>,
            children: usuari.naix,
        },
        {
            key: 'monitor',
            label: <><IdcardOutlined  style={{ marginRight: 6, color: Colors.colors.color1 }} />Carnet de monitor</>,
            children: usuari.monitor,
        },
        {
            key: 'CV',
            label: <><FileTextOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />CV</>,
            children: usuari.cv,
        },
        {
            key: 'Convivencia',
            label:
            (
            <>
            <TeamOutlined style={{ marginRight: 6, color: Colors.colors.color1 }}/>
             Convivència amb majors <br />de 26 amb dependència</>),
            children: <Tag>{usuari.convivencia ? "Sí" : "No"}</Tag>,
            
        },
        {
            key: 'sexuals',
            label: <><StopOutlined style={{ marginRight: 6, color: Colors.colors.color1 }} />Certificat de delictes sexuals</>,
            children: usuari.sexuals,
            span: 3,
        },
        
        {
                key: 'escoles',
                label: 'Escoles',
                span: 3,
                children: Array.isArray(usuariEscoles?.escoles) && usuariEscoles.escoles.length > 0 ? (
                usuariEscoles.escoles.map((e: any, idx: number) => (
                     <>
                    <Tag key={idx} color={Colors.colors.color4} style={{ marginBottom: 4 }} icon={<HomeOutlined />}>
                    {e.nom}
                    </Tag>
                    </>
                ))
                ) : (
                '—'
                ),
            },
            {
                key: 'rols',
                label: 'Rols',
                children: Array.isArray(usuariEscoles?.rols) && usuariEscoles.rols.length > 0 ? (
                usuariEscoles.rols.map((e: any, idx: number) => (
                    <Tag key={idx} color={Colors.colors.color5}>
                    {e.nom}
                    </Tag>
                ))
                ) : (
                '—'
                ),
            },


        ];
        

    if (isLoggedIn) {
        return (
            <div>
                <Toaster />
                <NavBar />
                {!loading ? (
                    <div className="general">
                        <Card bordered className="elemento">
                            <div className={"actionButtons"}>
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(defaultUser)}><BiPencil/></Button>
                                <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                    checkDades()}><BiRefresh/></Button>
                            </div>
                            <div className="titol">
                            <Avatar style={{ backgroundColor: Colors.colors.color5, }} size={60} icon={<UserOutlined />} />
                            <h4> {usuari.nom} </h4>
                            </div>

                                <Descriptions
                                    title="Dades de usuari"
                                    bordered
                                    size= "middle"
                                    items={Items}
                                    
                                />
                            <br/>
                                <Descriptions bordered column={1} size="small">
                                <Descriptions.Item key={15}
                                        label={"Configuració de l'app"}>
                                        <b style={{cursor: "pointer"}} onClick={() => setModal(true)}>Fes click per mostrar instruccions</b>
                                    </Descriptions.Item>
                                </Descriptions>



                            {nouElement && (
                                <ProfileModal element={usuari} onClose={handleCloseModal} visible={nouElement}
                                            page={page}/>
                            )}
                        </Card>
                    </div>
                ) : (

                    <div className="general">
                        <Card bordered className="elemento">
                            <div className={"actionButtons"}>
                                <Button title={"Editar"} style={{backgroundColor: Colors.colors.color2}} onClick={() =>
                                    afegirElement(defaultUser)}><BiPencil/></Button>
                                <Button title={"refrescar"} style={{backgroundColor: Colors.colors.color4}} onClick={() =>
                                    checkDades()}><BiRefresh/></Button>
                            </div>
                            <h4 className="titol">Dades usuari</h4>
                            <Descriptions bordered column={1} size="small">
                                <Descriptions.Item key={1}
                                                   label={"Dades"}>
                                    {"Carregant dades..."}
                                </Descriptions.Item>
                                <Descriptions.Item key={15}
                                                   label={"Configuració de l'app"}>
                                    <b style={{cursor: "pointer"}} onClick={() => setModal(true)}>Fes click per mostrar instruccions</b>
                                </Descriptions.Item>
                            </Descriptions>
                        </Card>
                    </div>
                )}
                <ConfiguracioAppModal onClose={handleCloseModal2} visible={modal} app={usuari.app} ios={usuari.ios}/>
            </div>
        );
    } else {
        return <Login />;
    }
};
export default Profile;
